import React from "react";
import { Link } from "react-router-dom";

// Style
import {
    FooterWrapper,
    FooterLeftSide,
    FooterRightSide,
    Content,
} from "../styles/LandingPageStyles";

// Images
import logo from "../../../images/footerLogo.svg";
import Nvidia from "../../../images/nvidia-inception-program.svg";

// Language
import { useTranslation } from "react-i18next";

// `connectLegalLinks` ({ privacy, terms } hrefs): on the StatsConnect pages the footer also lists the
// StatsConnect Privacy Notice and Terms; ConnectLayout builds the hrefs with the visit's sales-link code.
// The landing pages do not link to /connect (K9.3), so the links are opt-in. Client-side links keep the
// visit's in-memory attribution.
const Footer = ({ connectLegalLinks = null }) => {
    const { t } = useTranslation();

    return (
        <FooterWrapper>
            <FooterLeftSide>
                <img src={logo} alt={logo} />
                <div>
                    <h4>{t("footer.desc")}</h4>
                    <img src={Nvidia} width={160} alt={Nvidia} />
                </div>
            </FooterLeftSide>
            <FooterRightSide>
                <Content>
                    <h5>{t("footer.mainLink")}</h5>
                    <ul>
                        <li>
                            <a href="/#platform">{t("footer.platform")}</a>
                        </li>
                        <li>
                            <a href="/#services">{t("footer.services")}</a>
                        </li>
                        <li>
                            <a href="/#about">{t("footer.aboutUs")}</a>
                        </li>
                        <li>
                            <a href="/#contact">{t("footer.contactUs")}</a>
                        </li>
                    </ul>
                </Content>
                <Content>
                    <h5>{t("footer.otherLinks")}</h5>
                    <ul>
                        <li>
                            <a href="/privacy">{t("footer.privacyPolicy")}</a>
                        </li>
                        <li>
                            <a href="/terms">{t("footer.termsConditions")}</a>
                        </li>
                        {connectLegalLinks && (
                            <>
                                <li>
                                    <Link to={connectLegalLinks.privacy}>{t("footer.connectPrivacy")}</Link>
                                </li>
                                <li>
                                    <Link to={connectLegalLinks.terms}>{t("footer.connectTerms")}</Link>
                                </li>
                            </>
                        )}
                    </ul>
                </Content>
                <Content>
                    <h5>{t("footer.contactDetails")}</h5>
                    <ul>
                        <li>
                            <a href="mailto:sales@smrtstats.com">sales@smrtstats.com</a>
                        </li>
                        <li>
                            <span>
                                3 Charlotte, Honeypark, Dun Laoghaire, <br />Co. Dublin, A96 YF6A, Ireland
                            </span>
                        </li>
                    </ul>
                </Content>
            </FooterRightSide>
        </FooterWrapper>
    );
};

export default Footer;
